import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import Tabs from '../../../../components/Tabs';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/early-years/layoutProps';

const tabs = ['Playgroup', 'Children Centre', 'Kindergarten'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="en" pageKey="kik-kcc-curriculum">
        <h1>KIK/KCC Playgroup Curriculum</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <p>
              Our Playgroup is the first step towards building a firm foundation towards life-long learning and an ideal
              introduction to Kingston's bilingual (English and Putonghua) programme. Playgroup provides children with
              the essential base for Early Childhood Development. It allows the opportunity for children to:
            </p>
            <ul className="list">
              <li>Feel comfortable in an environment other than their own home</li>
              <li>Feel secure and valued by adults other than their parents</li>
              <li>Become accustomed to routines and expectations of Kindergarten</li>
              <li>Begin to develop a range of social skills and be comfortable with other children</li>
              <li>Experience being one of a larger group</li>
              <li>Become familiar with the range of equipment and activities available</li>
            </ul>
            <p>
              Please note that children attending our Playgroup must be accompanied by an adult for the whole session.
            </p>
            <table>
              <thead>
                <tr>
                  <th className="center">AM Classes</th>
                  <th className="center">PM Classes</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="center">
                    Monday, Wednesday, Friday<br />
                    8:45am to 11:15am
                  </td>
                  <td className="center">
                    Monday, Wednesday, Friday<br />
                    1:30pm to 4:00pm
                  </td>
                </tr>
                <tr>
                  <td className="center">
                    Tuesday, Thursday<br />
                    8:45am to 11:15am
                  </td>
                  <td className="center">
                    Tuesday, Thursday<br />
                    1:30pm to 4:00pm
                  </td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <p>
              Children in our 2 Year Old Classes are supported in their English and Putonghua learning by our
              fully-qualified, native-speaking teachers. Our caring and dedicated teachers are instrumental in the the
              natural acquisition of both languages and provide a strong basis for your child's continued learning.
            </p>
            <p>
              Carefully planned play based environments provide a safe and nurturing space for children to learn while
              learning engagements are designed to address the development of each child and guide their continued
              growth. The Children's Centre supports children in their transition to our Kindergarten as confident,
              active inquirers.
            </p>
            <table>
              <tbody>
                <tr>
                  <td className="center">
                    AM Class (5 Days Per Week)<br />
                    8:45am to 11:45am
                  </td>
                  <td className="center">
                    PM Class (5 Days Per Week)<br />
                    1:30pm to 4:30pm
                  </td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
        {tab === 2 && (
          <React.Fragment>
            <p>
              Kingston International Kindergarten is a warm and comfortable bilingual environment for children aged 3
              and 4. We understand that young children are naturally inquisitive and we have created the perfect
              environment for exploring the world through both English and Putonghua. It is here that our students begin
              their IBPYP journey, guided by native speaking, fully qualified early years practitioners. Four
              concept-driven PYP units of bilingual inquiry provide the framework for our engaging curriculum.
            </p>
            <p>
              We offer a developmentally appropriate curriculum that involves children in inquiry, critical thinking and
              active learning. Our pedagogy and environments are designed to support bilingual, immersed learning,
              providing the best possible foundation for continued language fluency and a bright future of communicating
              in the two most significant languages of our time.
            </p>
            <table>
              <tbody>
                <tr>
                  <td className="center">
                    AM Class (5 Days Per Week)<br />
                    8:45am to 11:45am
                  </td>
                  <td className="center">
                    PM Class (5 Days Per Week)<br />
                    1:30pm to 4:30pm
                  </td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
